import {
  Button,
  Grid,
  TextField,
  MenuItem,
  ListItemText,
  OutlinedInput,
  Select,
  InputLabel,
  FormControl,
  Modal,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  Divider,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../mui/LoadingOverlay";
import { adminsignup } from "../../api/apiAdmin";
import CountryAutocomplete from "../CountryAutocomplete";
import { selectgroups } from "../../redux/businessSlice";
import { useSelector } from "react-redux";
import { selectnodess } from "../../redux/nodesSlice";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const organizationPermissions = [
  { label: "Delete Organisation", value: "deleteOrganization" },
  { label: "Edit Organisation", value: "editOrganization" },
  { label: "Add Organisation", value: "addOrganization" },
  { label: "View Group", value: "viewBusinessGroup" },
  { label: "Specific Companies", value: "viewSpecificCompanies" },
  { label: "View All Organisation", value: "viewAllOrganization" },
  {
    label: "View Country Business Type Organisation",
    value: "viewCountryBusinessTypeOrganization",
  },
  {
    label: "View Business Type Organisation",
    value: "viewBusinessTypeOrganization",
  },
];

export function Adduser() {
  const businesses = useSelector(selectgroups);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const groups = useSelector(selectgroups);
  const allorganization = useSelector(selectnodess);

  const [selected, setSelected] = useState([]);
  const [selectedorgs, setSelectedOrgs] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [showPassword, setShowPassword] = useState(false); // 👈 for toggling password visibility

  const userPermissions = [
    { label: "Show User", value: "showUser" },
    { label: "Edit User", value: "editUser" },
    { label: "Delete User", value: "deleteUser" },
  ];

  const initialUser = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    businessType: "",
    userRole: "",
    userCountry: "",
  };

  const [userData, setUserData] = useState(initialUser);
  const [errors, setErrors] = useState({});

  const [selectedPermissions, setSelectedPermissions] = useState({
    deleteOrganization: false,
    editOrganization: false,
    addOrganization: false,
    showUser: false,
    editUser: false,
    deleteUser: false,
    viewAllOrganization: false,
    viewSpecificCompanies: false,
    viewCountryBusinessTypeOrganization: false,
    viewBusinessTypeOrganization: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (allorganization && businesses) {
      const filtered = allorganization?.filter((item) =>
        selectedValues?.includes(item?.data?.BusinessGroup)
      );
      setSelected(filtered);
    } else {
      setSelected([]);
    }
  }, [allorganization, businesses, selectedValues]);

  const handlePermissionChange = (event) => {
    const { value, checked } = event.target;
    if (
      [
        "viewSpecificCompanies",
        "viewAllOrganization",
        "viewCountryBusinessTypeOrganization",
        "viewBusinessTypeOrganization",
      ].includes(value)
    ) {
      setSelectedPermissions((prev) => ({
        ...prev,
        viewAllOrganization: false,
        viewSpecificCompanies: false,
        viewCountryBusinessTypeOrganization: false,
        viewBusinessTypeOrganization: false,
        [value]: checked,
      }));
    } else {
      setSelectedPermissions((prev) => ({
        ...prev,
        [value]: checked,
      }));
    }
  };

  const validateInput = () => {
    const errorObject = {};

    if (!userData.firstName) errorObject.firstName = "First Name is required";
    if (!userData.lastName) errorObject.lastName = "Last Name is required";
    if (!userData.email) errorObject.email = "Email is required";
    if (userData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(userData.email.trim())) {
        errorObject.email = "Please enter a valid email address";
      }
    }
    if (!userData.password) errorObject.password = "Password is required";
    if (!userData.businessType)
      errorObject.businessType = "Business Type is required";
    if (!userData.userRole) errorObject.userRole = "User Role is required";
    if (!userData.userCountry)
      errorObject.userCountry = "User Country is required";

    setErrors(errorObject);
    return Object.keys(errorObject).length === 0;
  };

  useEffect(() => {
    if (allorganization?.length > 0 && selectedorgs?.length > 0) {
      const filteredSelected = allorganization?.filter((item) =>
        selectedorgs?.includes(item?._id)
      );
      const filterbussinesscompanies = filteredSelected?.filter((item) =>
        selectedValues.includes(item?.data?.BusinessGroup)
      );
      const allorgdata = filterbussinesscompanies?.map((i) => i._id);
      setSelectedOrgs(allorgdata);
    }
  }, [selectedValues]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateInput()) {
      toast.error("Please fix the errors in the form.");
      return;
    }

    try {
      setLoading(true);
      const response = await adminsignup(
        userData.firstName,
        userData.lastName,
        userData.businessType,
        userData.userRole,
        userData.email,
        userData.password,
        { ...selectedPermissions },
        userData.userCountry,
        selectedorgs,
        selectedValues
      );
      if (response && response.status === 200) {
        toast.success("User created successfully");
        setUserData(initialUser);
        setSelectedPermissions({
          deleteOrganization: false,
          editOrganization: false,
          addOrganization: false,
          showUser: false,
          editUser: false,
          deleteUser: false,
          viewSpecificCompanies: false,
          viewAllOrganization: false,
          viewCountryBusinessTypeOrganization: false,
          viewBusinessTypeOrganization: false,
        });
        setOpenModal(false);
        navigate("/admin/userList");
      } else {
        toast.error(response?.data?.message || "Failed to create user");
      }
    } catch (error) {
      console.log(error, "error response");
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to create user"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="pe-2 ps-1">
        <h2 className="text-center mt-2 mb-2">Add User</h2>
        <Grid
          container
          spacing={2}
          className="border shadow"
          style={{ backgroundColor: "#0057EB08" }}
          sx={{ maxWidth: 600, mx: "auto", p: 3, mt: 2 }}
          justifyContent="flex-end"
        >
          <Grid item xs={12}>
            <TextField
              label="First Name"
              name="firstName"
              value={userData.firstName}
              onChange={handleChange}
              error={Boolean(errors.firstName)}
              fullWidth
              helperText={errors.firstName}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Last Name"
              name="lastName"
              value={userData.lastName}
              onChange={handleChange}
              error={Boolean(errors.lastName)}
              fullWidth
              helperText={errors.lastName}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              name="email"
              type="email"
              value={userData.email}
              onChange={handleChange}
              error={Boolean(errors.email)}
              fullWidth
              helperText={errors.email}
              variant="outlined"
              size="small"
            />
          </Grid>

          {/* 👇 Password Field with Eye Icon */}
          <Grid item xs={12}>
            <TextField
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={userData.password}
              onChange={handleChange}
              error={Boolean(errors.password)}
              helperText={errors.password}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              error={Boolean(errors.businessType)}
            >
              <InputLabel>Business Group</InputLabel>
              <Select
                name="businessType"
                value={userData.businessType}
                onChange={handleChange}
                label="Business Group"
              >
                {groups?.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item._id}>
                      {item.businessNature}
                    </MenuItem>
                  );
                })}
              </Select>
              {errors.businessType && (
                <small style={{ color: "red" }}>{errors.businessType}</small>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <CountryAutocomplete
              userData={userData}
              setUserData={setUserData}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              error={Boolean(errors.userRole)}
            >
              <InputLabel>User Role</InputLabel>
              <Select
                name="userRole"
                value={userData.userRole}
                onChange={handleChange}
                label="User Role"
              >
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="User">User</MenuItem>
              </Select>
              {errors.userRole && (
                <p style={{ color: "red" }}>{errors.userRole}</p>
              )}
            </FormControl>
          </Grid>

          {/* Conditionally Render Button for User Role */}

          <Grid item xs={12} container justifyContent="space-between">
            {userData.userRole === "User" && (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpenModal(true)}
              >
                Assign Permissions
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              size="medium"
              endIcon={<AddIcon />}
              onClick={handleSubmit}
            >
              Add User
            </Button>
          </Grid>
        </Grid>
      </div>

      {/* Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2">
            Assign Permissions
          </Typography>
          <Divider />
          <Box mt={2}>
            <Typography variant="subtitle1" className="fw-bold">
              Organization Permissions
            </Typography>
            {organizationPermissions?.map((permission) => (
              <FormControlLabel
                key={permission.value}
                control={
                  <Checkbox
                    checked={selectedPermissions[permission.value]}
                    onChange={handlePermissionChange}
                    value={permission.value}
                  />
                }
                label={permission.label}
              />
            ))}
            <Box display="flex"
      flexWrap="wrap"
      gap={{ xs: 1, sm: 2 }}>

            {/* business */}
            <FormControl
            
              sx={{ width: 200 }}
              disabled={!selectedPermissions.viewSpecificCompanies}
            >
              <InputLabel>Select Business</InputLabel>
              <Select
                multiple
                value={selectedValues} // State stores IDs of selected businesses
                onChange={(event) => {
                  const value = event.target.value;
                  if (value.includes("all")) {
                    // If "Select All" is clicked, toggle all businesses
                    setSelectedValues(
                      selectedValues.length === businesses.length
                        ? []
                        : businesses?.map((biz) => biz._id) // Store IDs
                    );
                  } else {
                    // Handle individual selections
                    setSelectedValues(value);
                  }
                }}
                input={<OutlinedInput label="All Business" />}
                renderValue={
                  (selected) =>
                    businesses
                      ?.filter((biz) => selected?.includes(biz._id)) // Filter businesses by selected IDs
                      ?.map((biz) => biz.businessNature) // Map to their names
                      .join(", ") // Display names in input
                }
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // Limit height for scrollable menu
                      overflow: "auto", // Enable scrolling
                    },
                  },
                }}
              >
                {/* "Select All" Checkbox */}
                <MenuItem value="all">
                  <Checkbox
                    checked={selectedValues.length === businesses.length}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {/* Individual Business Checkboxes */}
                {businesses?.map((option) => (
                  <MenuItem key={option._id} value={option._id}>
                    {" "}
                    {/* Use ID as value */}
                    <Checkbox
                      checked={selectedValues?.includes(option._id)}
                    />{" "}
                    {/* Check by ID */}
                    <ListItemText primary={option?.businessNature} />{" "}
                    {/* Display name */}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* companies */}
            <FormControl
              sx={{ width: 200 }}
              disabled={!selectedPermissions.viewSpecificCompanies}
            >
              <InputLabel>Select Companies</InputLabel>
              <Select
                multiple
                value={selectedorgs} // Holds IDs of selected companies
                onChange={(event) => {
                  const value = event.target.value;

                  if (value.includes("all")) {
                    // Handle "Select All" logic
                    if (selectedorgs.length === selected.length) {
                      // If all options are already selected, deselect all
                      setSelectedOrgs([]);
                    } else {
                      // Select all options
                      const allIds = selected?.map((item) => item._id);
                      setSelectedOrgs(allIds);
                    }
                  } else {
                    // Handle individual selection/deselection
                    setSelectedOrgs(value);
                  }
                }}
                input={<OutlinedInput label="All Companies" />}
                renderValue={(selectedIds) => {
                  // Display selected company names in the input
                  return selected
                    .filter((option) => selectedIds.includes(option._id))
                    ?.map((option) => option?.data?.companyName)
                    .join(", ");
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // Limit height for scrollable menu
                      overflow: "auto", // Enable scrolling
                    },
                  },
                }}
              >
                {/* "Select All" Checkbox */}
                <MenuItem value="all">
                  <Checkbox checked={selectedorgs.length === selected.length} />
                  <ListItemText primary="Select All" />
                </MenuItem>

                {/* Individual Company Checkboxes */}
                {selected?.map((option) => (
                  <MenuItem key={option?._id} value={option?._id}>
                    <Checkbox checked={selectedorgs.includes(option?._id)} />
                    <ListItemText primary={option?.data?.companyName} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            </Box>
          </Box>
          <Divider />
          <Box mt={2}>
            <Typography variant="subtitle1" className="fw-bold">
              User Permissions
            </Typography>
            {userPermissions?.map((permission) => (
              <FormControlLabel
                key={permission.value}
                control={
                  <Checkbox
                    checked={selectedPermissions[permission.value]}
                    onChange={handlePermissionChange}
                    value={permission.value}
                  />
                }
                label={permission.label}
              />
            ))}
          </Box>
          <Box mt={2} textAlign="right">
            <Button onClick={() => setOpenModal(false)}>Close</Button>
            <Button onClick={handleSubmit} variant="contained" sx={{ ml: 2 }}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>

      {loading && <LoadingOverlay />}
    </>
  );
}